import {handleActions} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';

const permissionReducer = handleActions(
    {
        [actionTypes.EDIT_PERMISSION_REPLY]: (state, action) => {
            if (action.payload.permissionId !== state.permissionId) {
                return state;
            }
            return {
                ...state,
                editMode: true,
            };
        },
        [actionTypes.TOGGLE_PERMISSION_DETAILS]: (state, action) => {
            if (action.payload.permissionId !== state.permissionId) {
                return state;
            }
            return {
                ...state,
                showDetails: !state.showDetails,
            };
        },
        [actionTypes.UPDATE_PERMISSION]: (state, action) => {
            if (action.payload.permissionReplyId !== state.reply.permissionReplyId) {
                return state;
            }
            return {
                ...state,
                updating: true,
            };
        },
        [actionTypes.UPDATE_PERMISSION_SUCCESS]: (state, action) => {
            if (action.payload.permissionReplyId !== state.reply.permissionReplyId) {
                return state;
            }
            return {
                ...state,
                reply: {
                    ...state.reply,
                    answer: action.payload.answer,
                },
                updating: false,
                editMode: false,
            };
        },
        [actionTypes.UPDATE_PERMISSION_ERROR]: (state, action) => {
            if (action.payload.permissionReplyId !== state.reply.permissionReplyId) {
                return state;
            }
            return {
                ...state,
                updating: false,
            };
        },
    },
    {},
);

const childAction = (state, action) => {
    return state.map(p => permissionReducer(p, action));
};

const permissionsReducer = handleActions(
    {
        [actionTypes.CHILD_PERMISSION_FETCH_SUCCESS]: (state, action) => action.payload,
        [actionTypes.EDIT_PERMISSION_REPLY]: childAction,
        [actionTypes.TOGGLE_PERMISSION_DETAILS]: childAction,
        [actionTypes.UPDATE_PERMISSION]: childAction,
        [actionTypes.UPDATE_PERMISSION_SUCCESS]: childAction,
        [actionTypes.UPDATE_PERMISSION_ERROR]: childAction,
    },
    [],
);

export default permissionsReducer;
